import application from "stimulus_application";
import { definitionsFromContext } from "stimulus/webpack-helpers";
import "./share_box.css";

const context = require.context("./", true, /_controller\.js$/);
application.load(definitionsFromContext(context));
